import Model from './model';
import Collection from './collection';
import View from './view';

export default {
	Model: Model,
	Collection: Collection,
	Views: {
		Main: View
	}
};
